import React from 'react';
import { Alert } from 'antd';

export default function SourceLimitation({ limitations = [] }) {
  if (!limitations.length) return null;

  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginTop: 12 }}
      message="Source limitation"
      description={
        <ul style={{ margin: 0, paddingLeft: 18 }}>
          {limitations.map((limitation) => (
            <li key={limitation}>{limitation}</li>
          ))}
        </ul>
      }
    />
  );
}
